const o = (r) => r.reduce((e, c) => e + c, 0);
export {
  o as SumArray
};
//# sourceMappingURL=index5.js.map
